import React, { useState, useEffect } from 'react';
import { post } from '../services/http-service';
import {
	Button,
	Box,
	InputLabel,
	Select,
	Dialog,
	ListItemText,
	MenuItem,
	OutlinedInput,
	FormControl,
	Typography,
} from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import storageService from 'src/services/storage-service';
import Alert from '@mui/material/Alert';
import DialogClose from './DialogClose';

const FIELDS = [
	{ key: 'company', label: 'Kommun/företag', required: true, value: '' },
	{ key: 'email', label: 'E-postadress', required: true, value: '' },
	{ key: 'unit', label: 'Förvaltning/enhet', value: '' },
	{ key: 'name', label: 'Namn', value: '' },
	{ key: 'phone', label: 'Telefon', value: '' },
];

function EBookOfferDialog({ open, onClose, selected = '' }) {
	const [errorMessage, setErrorMessage] = useState('');
	const [fields, setFields] = useState(FIELDS);

	useEffect(() => {
		setErrorMessage('');
		const user = storageService.load();
		FIELDS[0].value = user.organizationName;
		FIELDS[1].value = user.email.indexOf('@') > 0 ? user.email : '';
		FIELDS[3].value = user.displayName;
	}, [open]); // eslint-disable-line react-hooks/exhaustive-deps

	const changeField = (index, value) => {
		const newFields = [...fields];
		newFields[index].value = value;
		setFields(newFields);
	};

	const onSubmit = async () => {
		if (selected.length === 0) {
			return setErrorMessage(`Val av E-litteratur är obligatoriskt`);
		}

		for (let i = 0; i < 2; i++) {
			if (!fields[i].value) {
				return setErrorMessage(`${FIELDS[i].label} är obligatoriskt`);
			}
		}

		const form = new FormData();

		form.append('product.name', 'E-litteratur');
		form.append('product.items', selected);

		fields.forEach((f) => {
			form.append(f.key, f.value);
		});

		await post('/quote/new', form, true);

		setErrorMessage('');
		onClose(true);
	};

	if (!open) {
		return null;
	}

	return (
		<Dialog
			open={open}
			onClose={onClose}
			scroll="paper"
			aria-labelledby="scroll-dialog-title"
			aria-describedby="scroll-dialog-description"
			maxWidth="sm"
			fullWidth
			sx={{
				marginBottom: '24px',
			}}
		>
			<DialogTitle id="scroll-dialog-title">
				Beställ E-litteratur
			</DialogTitle>

			<DialogClose onClose={onClose} />

			<DialogContent sx={{ borderTop: '1px solid #e0e0e0' }}>
				<Typography variant="body2" gutterBottom>
					I vissa abonnemang ingår E-litteratur utan extra kostnad. Om
					E-litteratur inte ingår i ditt abonnemang kommer du att få
					en prisuppgift skickad till dig innan något läggs till. Du
					har alltid möjlighet att ta ställning till erbjudandet innan
					det aktiveras.
				</Typography>
			</DialogContent>

			<DialogContent dividers>
				{errorMessage && (
					<Box mb={2}>
						<Alert variant="filled" severity="error">
							{errorMessage}
						</Alert>
					</Box>
				)}

				<FormGroup>
					<TextField
						value={selected}
						variant="outlined"
						size="medium"
						margin="normal"
						fullWidth
						label={'E-litteratur'}
						readOnly
					/>
					{fields.map((field, index) => (
						<Box key={index}>
							{!field.checkbox && (
								<TextField
									onChange={(e) =>
										changeField(index, e.target.value)
									}
									value={field.value}
									variant="outlined"
									size="medium"
									margin="normal"
									required={field.required}
									fullWidth
									label={field.label}
								/>
							)}
							{field.checkbox && (
								<FormControlLabel
									key={'B' + index}
									control={
										<Checkbox
											checked={field.value}
											onChange={(event) =>
												changeField(
													index,
													event.target.checked
												)
											}
										/>
									}
									label={field.label}
								/>
							)}
						</Box>
					))}
				</FormGroup>
			</DialogContent>
			<DialogActions>
				<Button variant="contained" onClick={onSubmit}>
					Beställ
				</Button>
				<Button onClick={onClose}>Avbryt</Button>
			</DialogActions>
		</Dialog>
	);
}

EBookOfferDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func,
	selected: PropTypes.string,
};

export default EBookOfferDialog;
